import React, { useState, useEffect } from 'react'
//Library
import {
  Layout,
  Button,
  BackTop
} from 'antd'
import ReactGA from 'react-ga'
import { Link } from 'react-router-dom'
import { message } from 'antd'
// import { isSupported } from 'firebase/messaging'

//Icon SVG
import styles from './LayoutCMS.module.scss'
import IconExam from 'assets/icons/menu/icon-exam-selected.svg'
import IconExamGray from 'assets/icons/menu/icon-exam-non-selected.svg'
import IconMyExam from 'assets/icons/menu/icon-my-exam-selected.svg'
import IconMyExamGray from 'assets/icons/menu/icon-my-exam-non-selected.svg'
import IconGroup from 'assets/icons/menu/icon-group-selected.svg'
import IconGroupGray from 'assets/icons/menu/icon-group-non-selected.svg'
import IconBookMark from 'assets/icons/menu/icon-bookmark-selected.svg'
import IconBookMarkGray from 'assets/icons/menu/icon-bookmark-non-selected.svg'
import IconShopSelected from 'assets/icons/menu/icon-shop-selected.svg'
import IconShopNonSelected from 'assets/icons/menu/icon-shop-non-selected.svg'
import IconPretest from 'assets/icons/menu/icon-pretes-selected.svg'
import IconPretestGray from 'assets/icons/menu/icon-pretest-non-selected.svg'
//Components
import Footer from 'components/Footer/Footer'
import useAuth from 'context/auth'
import { logoutService } from 'api/auth'
import { USER_ROLE } from 'util/config'
import { HeaderCMS, HeaderGuest } from 'components/Header'
import { actionType } from 'reducers/auth'
import dayjs from 'dayjs'
import { getCookie, setCookie } from 'util/helper'
import 'util/firebase-connector'
import { TranslateLanguage } from 'util/Translate'
import { vacabLayoutCMS } from 'util/Translate.variable'

const translate = new TranslateLanguage()
translate.addMaping(vacabLayoutCMS)
const { Content, Sider } = Layout

const setIconMenu = (selectedIcon, icon) => (isSelect) => isSelect ? selectedIcon : icon

const userMenuSchema = {
  guest: [
    {
      text: translate.convert('ข้อสอบ'),
      getIcon: setIconMenu(IconExam, IconExamGray),
      path: '/home',
      activeKey: 'exam'
    },
    {
      text: translate.convert('บุ๊กมาร์ก'),
      getIcon: setIconMenu(IconBookMark, IconBookMarkGray),
      path: '/bookmark',
      activeKey: 'bookmark'
    },
  ],
  normalStudent: [
    {
      text: translate.convert('ข้อสอบ'),
      getIcon: setIconMenu(IconExam, IconExamGray),
      path: '/home',
      activeKey: 'exam'
    },
    {
      text: translate.convert('Pretest'),
      getIcon: setIconMenu(IconPretest, IconPretestGray),
      path: '/pretest',
      activeKey: 'pretest'
    },
    {
      text: translate.convert('บุ๊กมาร์ก'),
      getIcon: setIconMenu(IconBookMark, IconBookMarkGray),
      path: '/bookmark',
      activeKey: 'bookmark'
    },
    {
      text: translate.convert('ซื้อแพ็กเกจ'),
      getIcon: setIconMenu(IconShopSelected, IconShopNonSelected),
      path: '/package',
      activeKey: 'package'
    },
  ],
  schoolCollabStudent: [
    {
      text: translate.convert('ข้อสอบ'),
      getIcon: setIconMenu(IconExam, IconExamGray),
      path: '/home',
      activeKey: 'exam'
    },
    {
      text: translate.convert('กลุ่ม'),
      getIcon: setIconMenu(IconGroup, IconGroupGray),
      path: '/group',
      activeKey: 'group'
    },
    {
      text: translate.convert('Pretest'),
      getIcon: setIconMenu(IconPretest, IconPretestGray),
      path: '/pretest',
      activeKey: 'pretest'
    },
    {
      text: translate.convert('บุ๊กมาร์ก'),
      getIcon: setIconMenu(IconBookMark, IconBookMarkGray),
      path: '/bookmark',
      activeKey: 'bookmark'
    },

  ],
  schoolCollabTeacher: [
    {
      text: translate.convert('ข้อสอบ'),
      getIcon: setIconMenu(IconExam, IconExamGray),
      path: '/home',
      activeKey: 'exam'
    },
    {
      text: translate.convert('ข้อสอบของฉัน'),
      getIcon: setIconMenu(IconMyExam, IconMyExamGray),
      path: '/my-exam',
      activeKey: 'my-exam'
    },
    {
      text: translate.convert('กลุ่ม'),
      getIcon: setIconMenu(IconGroup, IconGroupGray),
      path: '/group',
      activeKey: 'group'
    },
    {
      text: translate.convert('บุ๊กมาร์ก'),
      getIcon: setIconMenu(IconBookMark, IconBookMarkGray),
      path: '/bookmark',
      activeKey: 'bookmark'
    },
  ]
}

const LayoutCMS = (props) => {
  const prop = props.children.props
  const { state: { user, isAuthenticated } } = useAuth()
  const [roleMenu, setRoleMenu] = useState(userMenuSchema.guest)
  const [defaultHover, setDefaultHover] = useState(-1)
  const [acceptCookie, setAcceptCookie] = useState(false)
  let exp = user?.mySubscription.map(scp => scp.expiresDate)[0]
  // const [supportBrowser, setSupportBrowser] = useState(false)
  const { dispatch } = useAuth()

  useEffect(() => {
    // set side bar ui
    if (isAuthenticated) {
      if (user.role === USER_ROLE.TEACHER) {
        setRoleMenu(userMenuSchema.schoolCollabTeacher)
      } else if (user.role === USER_ROLE.STUDENT && user.schoolCollabName) {
        setRoleMenu(userMenuSchema.schoolCollabStudent)
      } else if (user.role === USER_ROLE.STUDENT && !user.schoolCollabName) {
        setRoleMenu(userMenuSchema.normalStudent)
      }
    } else {
      setRoleMenu(userMenuSchema.guest)
    }
    // isSupported().then((suports) => {
    //   if (suports) {
    //     setSupportBrowser(true)
    //   }
    // })

    return () => props.children
  }, [])

  const sendGAEvent = (path) => {
    ReactGA.event({
      category: 'Menu',
      action: 'Click Left Side Menu',
      label: path
    })
  }
  const handleSignOut = async () => {
    message.error('แพ็กเกจของคุณหมดอายุแล้ว')
    const res = await logoutService()
    if (res.error) return message.error(`ไม่สามารถออกจากระบบได้ ${res.error}`)
    dispatch({ type: actionType.LOGOUT })
    props.children.props.history.push('/login')
    ReactGA.event({
      category: 'User',
      action: 'logout',
      label: 'logout'
    })
  }
  if (user?.role === USER_ROLE.TEACHER && (exp < dayjs(new Date()).unix())) {
    handleSignOut()
  }

  const handleAcceptCookie = () => {
    setCookie('acceptCookie', 'true')
    setAcceptCookie(true)
  }

  return (
    <div className={styles.content}>
      <BackTop />
      <Layout className={styles.divLayout}>
        {/* {header} */}
        {isAuthenticated ? <HeaderCMS {...props.children.props} user={user} /> : <HeaderGuest />}
        <Sider
          style={{
            overflow: 'hidden',
            height: '100vh',
            position: 'fixed',
            paddingTop: '92px',
            left: 0,
            backgroundColor: 'transparent'
          }}
        >
          <div className='logo' />
          <div className={styles.divMenu}>
            {
              roleMenu.map((menu, key) => (
                <div className={styles.divMenuItem} key={key}>
                  <Button
                    type='text'
                    datamenu-itemid={`Home-${menu.activeKey}`}
                    className={menu.activeKey === props.activeMenu ? styles.btnMenuSelected : styles.btnMenu}
                    onClick={async () => {
                      await sendGAEvent(menu.path)
                      prop.history.push(menu.path)
                    }}
                    onMouseEnter={() => setDefaultHover(menu.path)}
                    onMouseLeave={() => setDefaultHover(-1)}
                  >
                    <img alt='IconProfileDefault' src={menu.getIcon(menu.activeKey === props.activeMenu || defaultHover === menu.path)} style={{ marginRight: 8 }} /> {menu.text}
                  </Button>
                </div>
              ))
            }
          </div>
        </Sider>
        <Layout className='site-layout' style={{ marginLeft: 200, backgroundColor: 'transparent' }}>
          <Content style={{ margin: '24px', paddingTop: 40, overflow: 'initial', backgroundColor: 'transparent', display: 'flex', justifyContent: 'space-around' }}>
            <div className={styles.divChildren}>
              {props.children}
            </div>
          </Content>
        </Layout>
      </Layout>
      <Footer props={props.children.props} />
      {
        user || acceptCookie ? '' : !getCookie('acceptCookie') &&
          <div className={styles.navbarPDPA}>
            <div>
              <span>Sobtid junior มีการใช้คุ้กกี้เพื่อประสอบการการใช้งานที่ดีขึ้น </span>
              <Link to='/privacy-policy'>
                <span className={styles.linkAccept}>
                  อ่านนโยบายความเป็นส่วนตัว
                </span>
              </Link>
            </div>
            <Button onClick={handleAcceptCookie} type='primary' size={'small'}>ยอมรับ</Button>
          </div>
      }
    </div>
  )
}
export default LayoutCMS